import { render, staticRenderFns } from "./EditTehniquePage.vue?vue&type=template&id=1ec0b36d&scoped=true&"
import script from "./EditTehniquePage.vue?vue&type=script&lang=js&"
export * from "./EditTehniquePage.vue?vue&type=script&lang=js&"
import style0 from "./EditTehniquePage.vue?vue&type=style&index=0&id=1ec0b36d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0b36d",
  null
  
)

export default component.exports